import "./App.css";
import { ReactNode } from "react";

const UnAuthenticatedLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-gradient-to-br from-[#0f0f23] via-[#1a1a2e] via-[#16213e] via-[#0f3460] to-[#533483] relative overflow-hidden">
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_80%,rgba(120,119,198,0.3)_0%,transparent_50%),radial-gradient(circle_at_80%_20%,rgba(255,119,198,0.3)_0%,transparent_50%),radial-gradient(circle_at_40%_40%,rgba(120,219,255,0.2)_0%,transparent_50%)] pointer-events-none"></div>
      
      {/* Animated Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[length:50px_50px] animate-gridMove pointer-events-none"></div>
      
      {/* Floating Orbs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[20%] left-[10%] w-[60px] h-[60px] bg-gradient-to-br from-[rgba(120,119,198,0.4)] to-[rgba(255,119,198,0.4)] rounded-full blur-[1px] animate-float"></div>
        <div className="absolute top-[60%] right-[15%] w-[40px] h-[40px] bg-gradient-to-br from-[rgba(120,119,198,0.4)] to-[rgba(255,119,198,0.4)] rounded-full blur-[1px] animate-float-2s"></div>
        <div className="absolute bottom-[20%] left-[20%] w-[80px] h-[80px] bg-gradient-to-br from-[rgba(120,119,198,0.4)] to-[rgba(255,119,198,0.4)] rounded-full blur-[1px] animate-float-4s"></div>
        <div className="absolute top-[30%] right-[30%] w-[50px] h-[50px] bg-gradient-to-br from-[rgba(120,119,198,0.4)] to-[rgba(255,119,198,0.4)] rounded-full blur-[1px] animate-float-6s"></div>
      </div>
      
      {/* Content Wrapper */}
      <div className="relative z-10 w-full flex justify-center items-center p-8">
        {children}
      </div>
    </div>
  );
};

export default UnAuthenticatedLayout;
